const translations = {
    beginUsing: 'You can now begin using AcreConnect',
    licenseReady:
        'Have your Part 137 License approved by AcreConnect to best utilize all app features',
    noJobs: 'No Jobs Scheduled',
    organizationCreated: 'Organization Created',
    title: 'Welcome, {{firstName}}'
};

export default translations;
